import ENV from 'tio-employee/config/environment';
import Store from 'ember-data/store';
import { getOwner } from '@ember/owner';
import { createTioRequestManager } from 'tio-data/request-manager';
import { addError } from 'tio-common/utils/datadog';
import type ImpersonationService from 'tio-employee/services/impersonation';
import type SessionContextService from 'tio-employee/services/session-context';
import type SessionService from 'tio-employee/services/session';
import type NotificationsService from 'tio-reimagined/services/notifications';

export default class AppStore extends Store {
  // @ts-expect-error: need to do more research on how to type this properly
  constructor(...args) {
    super(...args);
    const owner = getOwner(this);

    this.requestManager = createTioRequestManager(this, {
      apiKey: ENV.apiKey,
      contentType: 'application/json',
      authKey: () => (owner?.lookup('service:session') as SessionService | undefined)?.publicKey,
      sessionRenewal: {
        passToken: false,
      },
      impersonation: {
        isImpersonated: () =>
          (owner?.lookup('service:impersonation') as ImpersonationService | undefined)
            ?.isImpersonated ?? false,
        confirmMutation: () => {
          const svc = owner?.lookup('service:impersonation') as ImpersonationService | undefined;
          return svc ? svc.confirmMutation() : Promise.resolve(true);
        },
      },
      response: {
        isAuthenticated: () =>
          (owner?.lookup('service:session') as SessionService | undefined)?.isAuthenticated ??
          false,
        onUnauthorized: () => {
          void (
            owner?.lookup('service:session-context') as SessionContextService | undefined
          )?.logout();
        },
        toastStatuses: [400, 403, 422],
        showToast: (message: string) => {
          (owner?.lookup('service:notifications') as NotificationsService | undefined)?.add(
            message,
            { appearance: 'error' }
          );
        },
        reportError: addError,
        getUserId: () =>
          (owner?.lookup('service:session-context') as SessionContextService | undefined)?.user
            ?.id as string | undefined,
      },
    });
  }
}
